<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="wrap" :class="index === 0 ? 'A' : 'B' " v-for="(item,index) in list" :key="index">
                            <div class="item-box">
                                <div class="tit">
                                    <span>
                                        {{item.store.name}}
                                    </span>
                                    <span>
                                        STOCK
                                    </span>
                                </div>
                                <div class="cont">
                                    <div class="process">
                                        <el-progress :text-inside="true" :stroke-width="16" :percentage="item.amount/item.contain * 100"
                                                     color="#FF1A8C" :format="()=>{}"></el-progress>
                                    </div>
                                    <div class="info">
                                        当前 <strong>{{item.amount}}</strong> / {{item.contain}}件
                                    </div>
                                </div>
                                <div class="stock">
                                    当前库存剩余 <strong>{{item.amount}}</strong> 件
                                </div>
                            </div>
                            <div class="item-box">
                                <div class="tit">
                                    <span>
                                        容积
                                    </span>
                                    <span>
                                         VOLUME
                                    </span>
                                </div>
                                <div class="cont">
                                    <div class="process">
                                        <el-progress :text-inside="true" :stroke-width="16" :percentage="item.useVolume / item.volume *100"
                                                     color="#FF1A8C" :format="()=>{}"></el-progress>
                                    </div>
                                    <div class="info">
                                        当前 <strong>{{item.useVolume.toFixed(2)}}</strong> / {{item.volume.toFixed(2)}}立方米
                                    </div>
                                </div>
                                <div class="stock">
                                    当前容积剩余 <strong>{{item.hasVolume.toFixed(2)}}</strong> 立方米
                                </div>
                            </div>
                            <div class="item-box">
                                <div class="tit">
                                    <span>
                                        存放时间
                                    </span>
                                    <span>
                                         STORAGE TIME
                                    </span>
                                </div>
                                <div class="cont">
                                    <div class="time-box">
                                        <div class="head">
                                            <span>
                                                开始
                                            </span>
                                            <span>
                                                {{new Date(item.createTime).$getWeek()}}
                                            </span>
                                        </div>
                                        <div class="value">
                                            {{new Date(item.createTime).$Format('yyyy年MM月dd日')}}
                                        </div>
                                    </div>
                                    <div class="split">
                                        <i class="iconfont icon-101fangxiang_xiangyou"></i>
                                    </div>
                                    <div class="time-box">
                                        <div class="head">
                                            <span>
                                                开始
                                            </span>
                                            <span>
                                                {{new Date(item.closeTime).$getWeek()}}
                                            </span>
                                        </div>
                                        <div class="value">
                                            {{new Date(item.closeTime).$Format('yyyy年MM月dd日')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-box">
                                <div class="tit">
                                    <span>
                                        费用（含税）
                                    </span>
                                    <span>
                                         Cost (tax included)
                                    </span>
                                </div>
                                <div class="cont">
                                    <div class="time-box cost">
                                        <div class="value">
                                            ${{item.totalFee.toFixed(2)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.next" @click="next()">
                    下一步
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "warehoseCheck",
        data() {
            return {
                list: [],
                count: ''
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.axios.post('/student/store/exp/list', {experiment: {id: this.$store.state.record.experiment.id}}).then(res => {
                    if (res.succeed && res.login) {
                        this.list = res.items.filter((item, index) => {
                            return item.store.country === this.$store.state.record.country
                        });
                    }
                })
            },
            next(){
                let n = this.$store.state.record.caseIndex;
                switch (n) {
                    case 1:
                        this.$router.push('/overseas-warehouses/handleOrdersOne');
                        break;
                    case 2:
                        this.$router.push('/overseas-warehouses/handleOrdersTwo');
                        break;
                    case 3:
                        this.$router.push('/overseas-warehouses/handleOrdersThree');
                        break;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    justify-content: center;

                    .wrap {
                        width: 596px;
                        height: 540px;
                        border: 1px dashed #004BFF;
                        background: #F0F4FD;
                        border-radius: 20px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: flex-start;
                        padding: 32px;
                        margin-right: 28px;
                        position: relative;
                        overflow: hidden;

                        .item-box {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            margin-bottom: 30px;

                            .tit {
                                margin-bottom: 12px;

                                span {
                                    color: #221814;

                                    &:first-child {
                                        font-size: 18px;
                                        font-weight: bolder;
                                    }

                                    &:last-child {
                                        font-size: 12px;
                                        margin-left: 2px;
                                    }
                                }
                            }

                            .cont {
                                display: flex;
                                align-items: center;

                                div.process {
                                    width: 308px;
                                    margin-right: 20px;

                                    ::v-deep .el-progress-bar__outer {
                                        background-color: #FFFFFF;
                                    }
                                }

                                div.info {
                                    font-size: 16px;

                                    strong {
                                        color: #FF1A8C;
                                        font-weight: bolder;
                                    }
                                }

                                div.time-box {
                                    width: 164px;
                                    height: 64px;
                                    padding: 12px;
                                    background-color: #FBB521;
                                    border-radius: 10px;
                                    color: #FFFFFF;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;

                                    &.cost {
                                        background-color: #815FBD;
                                    }

                                    .head {
                                        display: flex;
                                        justify-content: space-between;
                                    }

                                    .value {
                                        font-size: 18px;
                                    }
                                }

                                div.split {
                                    margin: 0 16px;

                                    i {
                                        font-size: 20px;
                                        color: #FBB521;
                                    }
                                }
                            }

                            div.stock {
                                margin-top: 12px;

                                e {
                                    font-weight: bolder;
                                }
                            }
                        }

                        &:before {
                            content: '';
                            border-bottom-right-radius: 20px;
                            position: absolute;
                            bottom: -34px;
                            right: -110px;
                            z-index: 1;
                            border-left: 160px solid transparent;
                            border-right: 160px solid transparent;
                            border-top: 160px solid #517FFB;
                            transform: rotate(-45deg);
                        }

                        &:after {
                            content: 'A仓库';
                            font-size: 20px;
                            font-weight: bolder;
                            position: absolute;
                            bottom: 38px;
                            right: 38px;
                            z-index: 2;
                            color: #FFFFFF;
                        }

                        &.B:after {
                            content: 'B仓库';
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
